import { render } from "./router_test_first.vue?vue&type=template&id=4e6b1c2b"
import script from "./router_test_first.vue?vue&type=script&lang=js"
export * from "./router_test_first.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__